module.exports = __webpack_public_path__ + "img/seminar (69).0317da6d.jpg";